import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-navy px-4 py-2 text-center" data-id="element-205" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-semibold leading-snug text-white sm:text-xs" data-id="element-206" data-mp="1ir7vcknq3lv6">
        <span className="sm:hidden" data-id="element-207" data-mp="1ip55q1qhfuqz">Instant digital download · Print at home</span>
        <span className="hidden sm:inline" data-id="element-208" data-mp="1dsxzs8y36j91">
          Instant digital download · Print at home · Made for curious kids ages 5–12
        </span>
      </p>
    </div>;
}